// src/services/pedidos/WhatsService.js
import { fetchData, postData } from '../Api';

export const conectarWhats = async (configWhatsId) => {
    return fetchData('/Whats/InstanceConnect', { configWhatsId });
};

export const createInstance = async (configWhatsId) => {
    return fetchData('/Whats/CreateInstance', { configWhatsId });
};

export const restartInstance = async () => {
    return fetchData('/Whats/RestartInstance');
};

export const getConnectionState = async () => {
    return fetchData('/Whats/ConnectionState');
};

export const getUrlApp = async () => {
    return fetchData('/WhatsAppWeb/GetUrlApp');
};

export const enviarMensagemTexto = async (contatoId, texto) => {
    return postData('/WhatsAppWeb/EnviaMensagemText', { contatoId, texto });
};
